const GESTURE_LOCK_SLOP = 10;
const AXIS_LOCK_RATIO = 1.25;

export type GestureAxis = 'horizontal' | 'vertical';

/** Lock swipe intent once movement clearly favors one axis over the other. */
export const resolveGestureAxis = (dx: number, dy: number): GestureAxis | null => {
  if (Math.abs(dx) <= GESTURE_LOCK_SLOP && Math.abs(dy) <= GESTURE_LOCK_SLOP) {
    return null;
  }
  if (Math.abs(dx) >= Math.abs(dy) * AXIS_LOCK_RATIO) {
    return 'horizontal';
  }
  if (Math.abs(dy) >= Math.abs(dx) * AXIS_LOCK_RATIO) {
    return 'vertical';
  }
  return null;
};
